var _excluded = ["isVisible", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import { slideInVertical } from "../../../animations/slideIn";
import OnColorContext from "../../../contexts/OnColorContext";
import { animationDuration, zIndex } from "../../../settings";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
var backgroundColor = "white";
var Container = styled.div.withConfig({
  componentId: "sc-12l57ts-0"
})(function (_ref) {
  var $isHidden = _ref.$isHidden,
    $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["display:", ";position:fixed;z-index:", ";bottom:", ";left:", ";right:", ";align-items:center;margin:auto;padding:", " ", " ", " ", ";border-radius:", ";background:", ";border:", " solid ", ";box-shadow:", ";backdrop-filter:blur(", ");-webkit-backdrop-filter:blur(", ");max-width:", ";animation:", " ", "s forwards;"], $isHidden ? "none" : "flex", zIndex.FloatingButtonMol, space(2), space(2), space(2), space(1.5), space(1.5), space(1.5), space(5), getBorderRadius(theme, "mlarge"), getColor(theme, backgroundColor), unit(1), getBorderColor(theme, $onColor, "extraLow"), getBoxShadow(theme, "big"), unit(30), unit(30), space(142), slideInVertical(), animationDuration.slow / 1000);
});
function FloatingBoxMol(_ref2) {
  var isVisible = _ref2.isVisible,
    children = _ref2.children,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(Container, _extends({
    $isHidden: !isVisible,
    $onColor: onColor
  }, restProps), /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: backgroundColor
  }, children));
}
export default FloatingBoxMol;